/**
 * @param {Object} productOptions
 */
export function normalizeProductOptions(productOptions) {
  const aspectValues = Object.values(productOptions);

  if (!aspectValues.length) {
    return [];
  }

  const aspectsNormalized = aspectValues.map((aspect) => {
    return {
      name: aspect.name,
      values: aspect.choices.map((choice) => choice.description),
    };
  });

  return aspectsNormalized;
}
